import { isApp } from '@/utils/EnvUtils';
import { JsBridge, messageMethodIsSupport } from '@/utils/JsBridge';

/**
 * 在小程序 web-view、App WebView 或普通浏览器中处理左上角「返回」：
 * 1. 微信小程序：wx.miniProgram.navigateBack
 * 2. App：closeWebview
 * 3. 其它：history.back
 */
export function navigateBackFromEmbedded(): void {
  if (isApp() && messageMethodIsSupport('closeWebview')) {
    JsBridge.closeWebview({ sourceFrom: 'h5' });
    return;
  }
  const wx = typeof window !== 'undefined' ? (window as unknown as { wx?: { miniProgram?: { navigateBack?: (opts: { delta?: number }) => void } } }).wx : undefined;
  if (wx?.miniProgram?.navigateBack) {
    try {
      wx.miniProgram.navigateBack({ delta: 1 });
      return;
    } catch {
      /* 降级 */
    }
  }
  window.history.back();
}
